module.exports = __webpack_public_path__ + "static/logo-4711b0f4fa747f40031b12ba5167b054.svg";